module.exports = {
	ENV: 'DEV',
	URL: '/api/',
	API: 'v2/',
	SOCKET: 'http://localhost:3030',
	PUBLICPATH: 'http://localhost:3060/public/',
	FORMPATH: 'http://localhost:10001/files-public-dev/public/forms/',
	LANDINGPAGEPATH: 'http://localhost:3060',
	CLASSIC_URL: 'http://localhost:8080/professional/application/',
	STATIC_MAPS_KEY: 'AIzaSyBz8DCi-zXpKspt_-LTIlhu-0vbLYMTNOA',
	GOOGLE_FONTS_KEY: 'AIzaSyDRwD9bJV8XncXBSWG9SQxM0sHHPso5rbw',
	STATUSPAGE: {
		pageId: 'xgxqnwgpzcyz',
		key: '91c46437-14a8-4b0b-b7f8-8e3df6ded05f',
		componentId: '1gr032v9zz1j'
	},
	PUSHER: {
		key: '0dae677b9a6736e36932',
		cluster: 'mt1'
	},
	SENTRY: {
		enable: false,
		env: 'development',
		dsn: null
	},
	PARAGON: {
		projectId: '939d5be7-da67-4a58-a1f8-779ac7390fe2',
		endpoint: 'https://zeus.paragon.upsales.com/projects',
		host: 'paragon.upsales.com',
		workerProxyPublicUrl: 'https://worker-proxy.paragon.upsales.com',
		custom: {
			1001309: '822c6d17-4183-4b39-a8f1-f95769e79060'
		}
	},
	CHECKIN_URL: 'http://localhost:3002/',
	CUSTOM_DOMAIN_CNAME: 'alphadomain.upsales.com',
	SPLIT_KEY: 'localhost',
	chatEnabled: true,
	GOOGLE_MAPS_KEY: 'AIzaSyDRvoBw4pueHRgI1K1taXQbRDV303gpqR4',
	GOOGLE_MAPS_UPSALES_MAP_ID: 'df76eaf7634c8288',
	WORKFLOW_URL: 'http://localhost:8080',
	MAPBOX_TOKEN: 'pk.eyJ1IjoiZHdpa2JlcmciLCJhIjoiY203dnhzbDZzMDE2MTJpc2o5dm10NHRsNSJ9.ecSQ-qyPl_mru-4NLfa_cg'
};
